const Cover = props => {
    return (
        <img src={props.src} alt={props.alt} style={{width: "100%", height: "100%", objectFit: "cover", opacity: 0.9, borderRadius: "5px"}}/>
    )
}

export default Cover;